import { constructs } from "../api/contructs";
import { CreateGenericReducer } from "./CreateGenericReducer";

export const SelectionsReducer = CreateGenericReducer(constructs["selection"]);
